import Phaser from 'phaser';
import IceCreamData from '../../IceCreamData';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../../UIAssetKeys';
import WorkArea from '../WorkArea';

export default class ScoopsView {
  /**
   * 
   * @param {Phaser.Scene} scene  
   * @param {WorkArea} workRef
   * @param {Phaser.GameObjects.Container} myContainer
   */
  constructor(scene, workRef, myContainer, infoRef) {
    this.scene = scene;

    this.delegate = workRef;
    this.container = myContainer;
    this.sundaeInfo = infoRef;

    this.scoopCount = 0;
    this.scoopOffset = IceCreamData.scoopOffset;
    this.scoopBase = IceCreamData.scoopBase;

    /** @type {Phaser.GameObjects.Image[]} */
    this.flavorSprites = [];
    const cnt = 5;
    for (let fs = 0; fs < cnt; fs++) {
      const s = new Phaser.GameObjects.Image(this.scene, 0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Flavor_1);
      s.x = -s.width;
      this.flavorSprites.push(s);
    }

    this.containerIsDish = false;
    let scoopLayers = [this.scene.add.container(), this.scene.add.container()];
    this.container.add(scoopLayers);

    /** @type {{sprite: Phaser.GameObjects.Image, layers: Phaser.GameObjects.Container[]}[]} */
    this.activeScoops = [];
    this.activeScoops.push({ sprite: null, layers: scoopLayers });
    scoopLayers = [this.scene.add.container(), this.scene.add.container()];
    this.container.add(scoopLayers);
    this.activeScoops.push({ sprite: null, layers: scoopLayers });
  }

  wipeScoops () {
    const len = this.sundaeInfo.scoops.length;
    for (let i = 0; i < len; i++) {
      const scoop = this.sundaeInfo.scoops[i];
      this.delegate.tossOutItem(scoop);
      const stuffCount = scoop.toppingStuff.length;
      for (let stuff = 0; stuff < stuffCount; stuff++) {
        const og = scoop.toppingStuff[stuff];
        this.delegate.tossOutTopping(og);
      }

      scoop.toppingStuff = [];
      scoop.x = -1111;
      scoop.activeInfo = null;
      this.delegate.removeScoopLayer(scoop);
    }
    this.sundaeInfo.scoops = [];
  }

  addScoop (value, containerY, containerIsDish) {
    this.prepForNewScoop(containerY, containerIsDish);

    const scoop = this.flavorSprites[this.scoopCount];
    let stuck = false;
    scoop.toppingStuff = [];
    scoop.flavorValue = value;
    this.scoopCount++;
    if (this.scoopCount > this.flavorSprites.length - 1) {
      this.scoopCount = 0;
    }

    scoop.setFrame(`Flavor+${value}`).setOrigin(0.5);
    scoop.x = this.delegate.workAreaPostions.centerX;
    scoop.y = this.delegate.workAreaPostions.top - scoop.height;

    if (this.sundaeInfo.container >= 1) {
      stuck = scoop;
    }
    else {
      this.delegate.tossOutItem(scoop, 800);
    }
    return stuck;
  }

  prepForNewScoop (containerY, containerIsDish) {
    this.containerIsDish = containerIsDish;
    let scoopLen = this.sundaeInfo.scoops.length;
    let scoop = null;
    if (scoopLen >= 2) {
      scoop = this.sundaeInfo.scoops.shift();
      scoopLen = this.sundaeInfo.scoops.length;
      this.delegate.tossOutItem(scoop);
      const stuffCount = scoop.toppingStuff.length;
      for (let i = 0; i < stuffCount; i++) {
        const og = scoop.toppingStuff[i];
        this.delegate.tossOutTopping(og, 400);
      }
      scoop.toppingStuff = [];
      scoop.y = -1111;
      scoop.activeInfo = null;
      this.delegate.removeScoopLayer(scoop);

      let remainingScoop = null;
      for (let st = 0; st < scoopLen; st++) {
        remainingScoop = this.sundaeInfo.scoops[st];

        let scoopY = containerY - (scoop.height / 2);
        scoopY -= st * IceCreamData.scoopOffset / 2;

        this.scene.tweens.killTweensOf(remainingScoop);
        ABCyaPhaser.Tweens.addTween(remainingScoop, 600, { y: scoopY, easeParams: [2, 5] }, Phaser.Math.Easing.Elastic.Out);
      }
    }
  }
}